<template>
  <div>
    <e-dialog
      :dialog-title="'低活跃商品'"
      :center-dialog-visible="visible"
      :popup-width="'900px'"
      :popup-top="'23vh'"
      :close-model="true"
      button-tip="我知道了"
      :is-show-cancel="false"
      @submitPopupData="resetPopupData"
      @resetPopupData="resetPopupData"
    >
      <div class="active-tips">
        <p>
          1、以下商品为60天及以上未产生交易的低活跃商品，低活跃商品平台有权进行停用，为不影响商品正常销售，还请关注！
        </p>
        <p>2、统计范围为“交易成功”状态的订单，每天统计截止到前一天的订单。</p>
      </div>
      <e-search
        :data="listQuery"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        :count="5"
        :width="filterInfo.width"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
        @handleFocus="focusClassify"
      ></e-search>
      <div style="margin: 10px 0">
        <eui-btn @click="exportCompanySkuExcel">导出</eui-btn>
      </div>
      <ETableList :loading="loading" :table-data="tableData" :table-label="tableLabel"></ETableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :page-size="listQuery.pageSize"
          :total="total"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </e-dialog>

    <!-- 所属分类 -->
    <classifyTree
      :classify-visible="classifyVisible"
      :category-tree-data="categoryTreeData"
      :default-checked-keys="defaultCheckedKeys"
      @submitPopupData="classifySubmitPopupData"
      @resetPopupData="classifyResetPopupData"
    ></classifyTree>
  </div>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import agreementApi from '@/modules/projectA/api/agreement/index';
import ESearch from '@/modules/projectA/components/common/e-search';
import ETableList from '@/modules/projectA/components/common/e-table-list.vue';
import utils, { fileExportResponseError } from '@/modules/projectA/utils/utils';
import ClassifyTree from './classifyTree';

export default {
  components: { EDialog, ESearch, ClassifyTree, ETableList },
  props: { visible: Boolean, info: Object },
  data() {
    return {
      // 所属分类
      classifyVisible: false,
      classifyData: null,
      defaultCheckedKeys: [],
      categoryTreeData: [],

      loading: false,
      listQuery: {
        skuCode: '',
        skuName: '',
        underactiveness: 1,
        brandName: '',
        categoryIdList: [],
        categoryName: '',
        pageSize: 10,
        pageNum: 1,
        // agreementId: this.info.agreementId,
      },
      cloneListQuery: {},
      total: 0,
      tableData: [],
      filterInfo: {
        data: {
          skuCode: '',
          skuName: '',
          categoryIdList: [],
          underactiveness: 1,
          brandName: '',
        },
        fieldList: [
          { label: '商品编号', type: 'input', value: 'skuCode' },
          { label: '商品名称', type: 'input', value: 'skuName' },
          {
            label: '低活天数',
            type: 'select',
            value: 'underactiveness',
            list: 'underactivenessList',
          },
          /* 组件 类目名称 */
          { label: '类目名称', value: 'categoryName', type: 'dialog', placeholder: '支持多选' },
          { label: '品牌名称', type: 'input', value: 'brandName' },
        ],
        /** 搜索/重置区域是否隐藏 */
        // btnHidden: true,
        /** 组件尺寸 */
        // size: 'small',
        /** 默认展示搜索条件 */
        count: 100,
        /** label/item 宽度 */
        width: {
          labelWidth: 85,
          itemWidth: 155,
        },
        /** 配置项 */
        btnStyle: [
          { icon: 'el-icon-search', text: '过滤', type: 'primary' },
          { icon: 'el-icon-refresh', text: '重置' },
        ],
      },
      listTypeInfo: {
        underactivenessList: [
          { id: 1, name: '60天及以上低活' },
          { id: 2, name: '90天及以上低活' },
        ],
      },
      tableLabel: [
        {
          label: '商品编号',
          param: 'skuCode',
          align: 'center',
          minWidth: '160',
        },
        {
          label: '商品名称',
          param: 'skuName',
          align: 'center',
          minWidth: '180',
        },
        {
          label: '类目名称',
          param: 'categoryName',
          align: 'center',
          minWidth: '100',
        },
        {
          label: '计量单位',
          param: 'unitValue',
          align: 'center',
          minWidth: '100',
        },
        {
          label: '品牌',
          param: 'brandName',
          align: 'center',
          minWidth: '100',
        },

        {
          label: '平台价(元)',
          param: 'skuPrice',
          align: 'center',
          minWidth: '100',
        },
        {
          label: '协议价(元)',
          param: 'agreementPrice',
          align: 'center',
          minWidth: '100',
        },
        {
          label: '商品状态',
          param: 'companyShowStatus',
          align: 'center',
          minWidth: '200',
          /* render(row) {
            let str = '';
            switch (row.skuStatus) {
              case 1:
                str = '正常';
                break;
              case 2:
                str = '供应商停用';
                break;
              case 3:
                str = '平台停用';
                break;
              default:
                str = '';
            }
            return str;
          }, */
        },
      ],
    };
  },
  computed: {},
  mounted() {
    // agreementId = 28; supplierCompanyId = 113511;
    const { agreementId, secondCompanyId: supplierCompanyId } = this.info;
    this.listQuery.agreementId = agreementId;
    this.listQuery.supplierCompanyId = supplierCompanyId;
    const data = this.$options.data().listQuery;
    this.cloneListQuery = { ...data, agreementId, supplierCompanyId };
    this.getList(this.cloneListQuery);
  },
  methods: {
    async getList(params) {
      try {
        const { code, data } = await agreementApi.querySkuByPage(params);
        if (code === '200') {
          const { records = [], total = 0 } = data;
          this.tableData = [...records];
          this.total = total;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async exportCompanySkuExcel() {
      const res = await agreementApi.exportCompanySkuExcel(this.listQuery);
      if (res.type === 'application/json') {
        fileExportResponseError(res);
      } else {
        utils.downFile(res, '低活跃商品');
      }
    },
    // 选择所属分类
    focusClassify() {
      this.getAllCategoryTree();
      if (this.listQuery.categoryIdList?.length) {
        this.defaultCheckedKeys = this.listQuery.categoryIdList;
      }
      this.classifyVisible = true;
    },
    async getAllCategoryTree() {
      const params = {
        agreementId: this.info.agreementId,
      };
      const res = await agreementApi.getSharedResourceAllCategoryTree(params);
      if (res.code === '200') {
        this.categoryTreeData = res.data.children;
      }
    },
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.classifyVisible = false;
    },

    // 所属分类确定
    classifySubmitPopupData(val) {
      // this.defaultCheckedKeys = val.map(item=>item.categoryId)
      const filterNode = [];
      val.map((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      console.log(filterNode, '过滤后的categoryId');
      this.listQuery.categoryIdList = filterNode.map((item) => item.categoryId);
      const arr = val.map((item) => item.categoryName);
      this.listQuery.categoryName = arr.join('、');
      this.classifyVisible = false;
    },

    handleSearch(val) {
      console.log(val);
      this.listQuery = { ...val, pageNum: 1, pageSize: 10 };
      this.getList(this.listQuery);
    },
    handleClear() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },

    handleSizeChange(size) {
      this.listQuery.pageSize = size;
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    handleCurrentChange(page) {
      this.listQuery.pageNum = page;
      this.getList(this.listQuery);
    },
    resetPopupData() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.active-tips {
  margin-bottom: 10px;
  padding: 6px;
  border: 1px solid #ccc;
  font-size: 12px;
  color: #2587ff;
}
</style>
